import React from 'react';
import PropTypes from 'prop-types';

const SCRIPT_ID = 'cloudflare-turnstile-api';
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

class Turnstile extends React.Component {
  static propTypes = {
    errorMessage: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
    ]),
    onTokenChange: PropTypes.func.isRequired,
    resetKey: PropTypes.number,
  }

  static defaultProps = {
    errorMessage: null,
    resetKey: 0,
  }

  componentDidMount() {
    this.loadTurnstile();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.resetKey !== this.props.resetKey &&
      this.widgetId !== undefined &&
      window.turnstile
    ) {
      window.turnstile.reset(this.widgetId);
      this.props.onTokenChange(null);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;

    if (
      this.widgetId !== undefined &&
      window.turnstile &&
      window.turnstile.remove
    ) {
      window.turnstile.remove(this.widgetId);
    }
  }

  loadTurnstile = () => {
    if (window.turnstile) {
      this.renderTurnstile();
      return;
    }

    const existingScript = document.getElementById(SCRIPT_ID);

    if (existingScript) {
      existingScript.addEventListener('load', this.renderTurnstile);
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.addEventListener('load', this.renderTurnstile);

    document.head.appendChild(script);
  }

  renderTurnstile = () => {
    if (
      this.unmounted ||
      !this.container ||
      !window.turnstile ||
      this.widgetId !== undefined
    ) {
      return;
    }

    const sitekey = window.gon && window.gon.TURNSTILE_SITE_KEY;

    if (!sitekey) {
      return;
    }

    this.widgetId = window.turnstile.render(this.container, {
      sitekey,
      action: 'signup',
      appearance: 'interaction-only',
      callback: this.handleSuccess,
      'expired-callback': this.handleExpired,
      'error-callback': this.handleError,
    });
  }

  handleSuccess = (token) => {
    this.props.onTokenChange(token);
  }

  handleExpired = () => {
    this.props.onTokenChange(null);
  }

  handleError = () => {
    this.props.onTokenChange(null);
  }

  formattedErrorMessage = () => {
    const { errorMessage } = this.props;

    if (Array.isArray(errorMessage)) {
      return errorMessage.join(', ');
    }

    return errorMessage;
  }

  render() {
    const errorMessage = this.formattedErrorMessage();

    return (
      <React.Fragment>
        <div
          className='margin-bottom-10'
          ref={(container) => {
            this.container = container;
          }}
        />
        {
          errorMessage &&
          <div className='margin-bottom-10'>
            {errorMessage}
          </div>
        }
      </React.Fragment>
    );
  }
}

export default Turnstile;
